const sortTable = () => {
  let filter = document.getElementById("res-filter");
  if (filter) {
    filter.addEventListener("keyup", filterList);
    function filterList() {
      let srch = filter;
      let val = srch.value.toLowerCase();
      let valArr = val.split(" ");
      let tbl = document.getElementById("res-table");
      let tblLength = tbl.rows.length;
      if (tblLength != 0) {
        for (let i = 1; i < tblLength; i++) {
          tbl.rows[i].style.display = "table-row";
          for (let j = 0; j < valArr.length; j++) {
            if (
              tbl.rows[i].textContent.toLowerCase().indexOf(valArr[j]) === -1
            ) {
              tbl.rows[i].style.display = "none";
            }
          }
        }
      }
    }
  }
};
export { sortTable };
